import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Customer } from '../../models/customer';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter, debounceTime, map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import * as fromBase from '../../../base/reducers';
import * as status from '../../../base/actions/status.actions';

@Component({
  selector: 'app-customer-selection-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss']
})
export class CustomerSelectionPageComponent implements OnInit, AfterViewInit {

  searchField = new FormControl()

  @Input() customers: Customer[]
  @Input() customerSelected: boolean
  @Input() loading: boolean
  @Output() onExpand = new EventEmitter()
  @Output() onSearch = new EventEmitter<string>()
  @Output() onSelect = new EventEmitter<Customer>()

  @ViewChild('search') searchInputField: ElementRef;

  searchForm: FormGroup
  lastKeyTime = Date.now();

  fullWidthView$: Observable<boolean>

  constructor(private fb: FormBuilder,
              private store: Store<any>
              ) {


    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )

      // this page has no header
      this.store.dispatch(new status.SetHeader(false));

  }

  ngOnInit() {
    this.searchField.valueChanges.pipe(
      debounceTime(500),
     ).subscribe(value => {
       if (value) {
         this.onSearch.emit(value)
       }
       else {
        this.onSearch.emit('')
       }
     })
  }

  ngAfterViewInit() {
    this.searchInputField.nativeElement.focus();
  }

  selectCustomer(customer: Customer) {
    this.onSelect.emit(customer)
  }

  resetSearch() {
    this.searchField.setValue('');
  }

  expand() {
    this.onExpand.emit()
  }

}
